import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
} from '@mui/material'
import { listFromKV } from '../../../Functions/ListItemGenerator'
import { useUserContext } from '../../../Contexts/UserConfig'
import {
  useVesselContext,
  vesselDialogs,
  VesselViewFields,
} from '../../../Contexts/Modules/SampleModule/VesselModule'
import { tsCodeSetValue } from '../../../Typescript/API_Response'

function MoveDialog() {
  const { openDialog, setOpenDialog } = useVesselContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const { vesselQuery, setFields } = useVesselContext()
  return (
    <Dialog
      open={openDialog === vesselDialogs.MOVE}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Select a new holding'}</DialogTitle>
      <DialogContent>
        <Select
          fullWidth
          name="vesselLocation"
          defaultValue={''}
          onChange={(e: any) => {
            setFields((f: VesselViewFields) => {
              return { ...f, holdingID: e.target.value }
            })
            setOpenDialog(vesselDialogs.MOVE_CONFIRM)
          }}
        >
          {listFromKV(
            loginConfig?.CodeSets?.['KV-Holdings'].values.filter(
              (c: tsCodeSetValue) =>
                c.CodeValue !== vesselQuery.data?.HoldingID,
            ) ?? [],
            loadingConfig || vesselQuery.isLoading,
            '',
          )}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MoveDialog
